import React from 'react';

export const ThemeContext = React.createContext( {} );

export const ThemeProvider = ThemeContext.Provider;
